import React from 'react'
import { Field, FieldProps } from 'react-final-form'
import Media from 'react-media'

import Slider from '@cinch/oxd-components/filter-range/src'
import SVG from '@cinch/oxd-components/svg/src'
import { SVGProps } from '@cinch/oxd-components/svg/src/svg.component'
import { FREQUENCY_OPTIONS } from '@cinch/oxd-pages/lifestyle/src/constants'
import { setToInt } from '@cinch/oxd-utils/form/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import styles from './distance.module.css'
import houseIllustration from './icons/house.svg'
import mordorIllustration from './icons/mordor.svg'
import motorwayIllustration from './icons/motorway.svg'

const valueFormatter = (value: any) => FREQUENCY_OPTIONS[value]

const sliderOptions = {
  valueFormatter,
  parse: setToInt,
  min: 0,
  max: FREQUENCY_OPTIONS.length - 1,
  step: 1,
}

const Illustration: React.FC<SVGProps> = (props) => {
  return (
    <Media defaultMatches={true} query={tokens.customMedia.s}>
      {(matches) => (matches ? <SVG width={120} height={50} {...props} /> : null)}
    </Media>
  )
}

const FieldComponent = (props: FieldProps) => <Field component={Slider} className={styles.rangeField} {...props} />

const DistanceFields: React.FC<{ i18n: Cinch.WebAppTranslations['lifestyle']['distance'] }> = ({ i18n }) => (
  <>
    <div className={styles.rangeSection}>
      <FieldComponent name="distanceShort" label={i18n.distanceShort} {...sliderOptions} />
      <Illustration children={houseIllustration} className={styles.illustration} />
    </div>
    <div className={styles.rangeSection}>
      <FieldComponent name="distanceMedium" label={i18n.distanceMedium} {...sliderOptions} />
      <Illustration children={motorwayIllustration} className={styles.illustration} />
    </div>
    <div className={styles.rangeSection}>
      <FieldComponent name="distanceLong" label={i18n.distanceLong} {...sliderOptions} />
      <Illustration children={mordorIllustration} className={styles.illustration} />
    </div>
  </>
)

export default DistanceFields
